import {
  UseBase64StringDownloadProps,
  UseBase64StringDownloadResponse,
} from "./types";

export function useDownloadBase64String(): UseBase64StringDownloadResponse {
  const fn = async ({
    base64String,
    fileName,
    blobType,
  }: UseBase64StringDownloadProps) => {
    if (!base64String || !fileName) {
      return;
    }

    const binaryString = atob(base64String);
    const binaryData = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      binaryData[i] = binaryString.charCodeAt(i);
    }

    // Create a Blob object from the binary data array
    const blob = new Blob([binaryData], { type: blobType });

    // Create a link element with a download attribute
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Add the link element to the DOM and click it to start the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link element and revoking the object URL
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };

  return {
    downloadBase64String: fn,
  };
}
